export const colors = {
  orange: '#f76707',
  purple: '#7048e8',
  pink: '#d6336c',
  teal: '#0ca678'
};
